<template>
  <picture>
    <div class="sizer" ref="sizer"></div>

    <img :src="small" :alt="alt" />
    <img v-if="url" :src="url" :alt="alt" />
  </picture>
</template>
<script lang="ts" setup>
import type { SupabaseClient } from "@supabase/supabase-js";
import {
  useElementSize,
  useElementVisibility,
  useDevicePixelRatio,
} from "@vueuse/core";

const props = defineProps<{
  bucket: string;
  path: string;
  alt?: string;
}>();

type TransformOptions = NonNullable<
  NonNullable<
    Parameters<ReturnType<SupabaseClient["storage"]["from"]>["getPublicUrl"]>[1]
  >["transform"]
>;

const client = useNuxtApp().$supabase?.client as SupabaseClient;

const sizer = ref<HTMLDivElement>();
const size = useElementSize(sizer);
const visible = useElementVisibility(sizer);
const { pixelRatio } = useDevicePixelRatio();

const small = computed(() => {
  const {
    data: { publicUrl },
  } = client.storage.from(props.bucket).getPublicUrl(props.path, {
    transform: { width: 20, height: 20, resize: "contain" },
  });
  return publicUrl;
});
const url = computed(() => {
  if (!size.width.value || !size.height.value) return null;

  const transform: TransformOptions = {
    width: Math.round(size.width.value * pixelRatio.value),
    height: Math.round(size.height.value * pixelRatio.value),
    resize: "contain",
  };

  const {
    data: { publicUrl },
  } = client.storage.from(props.bucket).getPublicUrl(props.path, {
    transform,
  });
  return publicUrl;
});
</script>
<style scoped>
picture {
  position: relative;
  width: 100%;
  height: 100%;
  display: grid;
  grid: 1fr / 1fr;
  justify-items: stretch;
}

picture > * {
  grid-area: 1 / 1 / 2 / 2;
}

picture > .sizer {
  position: absolute;
  inset: 0px;
}

picture img {
  max-width: 100%;
}
</style>
